"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var colors_1 = require("../styles/colors");
var typography_1 = require("../styles/typography");
var button = function (_a) {
    var type = _a.type, size = _a.size;
    var colors = kButtonTypeColors[type];
    var dimensions = kButtonDimensions[size];
    var borderColor = colors.border === 'none' ? 'none' : colors_1.getHex(colors.border);
    return typestyle_1.style(__assign({}, typography_1.getTextCSS('button'), { 
        // general styles to make an anchor look buttonish
        textDecoration: 'none', justifyContent: 'center', whiteSpace: 'nowrap', 
        // colors
        backgroundColor: colors.background === 'none' ? 'none' : colors_1.getHex(colors.background), border: "1px solid " + borderColor, color: colors_1.getHex(colors.text), 
        // sizing
        display: 'inline-flex', alignItems: 'center', height: dimensions.height + "px", padding: "0 " + dimensions.horizontalPadding + "px", 
        // roundiness
        borderRadius: dimensions.height * 0.5 + "px" }));
};
exports.styles = {
    button: button,
};
var kButtonTypeColors = {
    primary: {
        background: 'brand1',
        border: 'brand1',
        text: 'white',
    },
    secondary: {
        background: 'grey3',
        border: 'grey3',
        text: 'brand1',
    },
    light: {
        background: 'grey4',
        border: 'grey3',
        text: 'brand1',
    },
    disabled: {
        background: 'grey2',
        border: 'grey2',
        text: 'white',
    },
    outline: {
        background: 'white',
        border: 'brand1',
        text: 'brand1',
    },
    special: {
        background: 'brand4',
        border: 'brand4',
        text: 'white',
    },
    transparent: {
        background: 'none',
        border: 'none',
        text: 'brand1',
    },
};
var kButtonDimensions = {
    large: {
        height: 48,
        horizontalPadding: 32,
    },
    small: {
        height: 32,
        horizontalPadding: 16,
    },
};
